import { render, staticRenderFns } from "./EditLinkage.vue?vue&type=template&id=4d249f14&scoped=true&"
import script from "./EditLinkage.vue?vue&type=script&lang=js&"
export * from "./EditLinkage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d249f14",
  null
  
)

export default component.exports